export default __webpack_public_path__ + "static/media/logo.37b0e6ae.png";